import { Mapper } from "../../../../base/utils/mapper";
import { DoseModel } from "../../../../domain/models/consult/dose.model";
import { DoseEntity } from "../entities/dose.entity";

export class DoseImplementationRepositoryMapper extends Mapper<DoseEntity, DoseModel> {
    mapFrom(param: DoseEntity): DoseModel {
        return {
            data:param.data,
            isSuccess:param.isSuccess,
            message:param.message,
            errors:param.errors
        };
    }
    mapTo(param: DoseModel): DoseEntity {
        return {
            data:param.data,
            isSuccess:param.isSuccess,
            message:param.message,
            errors:param.errors
        }
    }
}